export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  MANAGER: "Manager",
  SENIOR_MANAGER: "Senior Manager",
  DIRECTOR: "Director",
  ACCOUNTANT: "Accountant",
  MANAGEMENT: "Management",
  AUGMENTED_ADMIN: "Augmented Admin",
  TIMELOG_ADMIN: "Timelog Admin",
  TIMELOG_EMPLOYEE: "Timelog Employee",
  TIMELOG_HR: "Timelog HR",
  HANDS_ADMIN: "H&S Admin",
  HANDS_USER: "H&S User",
  AMELIO_ADMIN: "Amelio Admin",
};
